<template>
<section>
  <va-modal
    ref="showClusterModal"
    :value="isOpen"
    :showOkay="false"
    :cancelText="$t('leads.back')"
    @cancel="closeModal">
    <div slot="header" class="modal-title">
      <span>{{cluster.name}}</span>
    </div>

    <div class="modal-header-actions d-flex justify-content-end">
      <va-popover
        placement="left"
        :message="$t('clusters.labels.update_cluster')"
        v-if="clusterContainsUser">
        <va-button
          large
          class="va-button-rounded"
          icon="fa fa-pencil"
          color="gray"
          @click="onClickUpdateCluster">
        </va-button>
      </va-popover>
    </div>

    <div class="evollu-form">
      <h5>
        <b>{{`${$t('clusters.labels.entities')} (${cluster.entities.length})`}}</b>
      </h5>
      <ShowPartialOrFullList :data="cluster.entities">
        <ul slot-scope="{ data }">
          <li v-for="entity in data" :key="entity.id">
            {{formatEntity(entity)}}
          </li>
        </ul>
      </ShowPartialOrFullList>
    </div>
    <div>
      <h5>
        <b>{{`${$t('clusters.labels.users')} (${cluster.users.length})`}}</b>
      </h5>
      <ShowPartialOrFullList :data="cluster.users">
        <ul slot-scope="{ data }">
          <li v-for="user in data" :key="user.id">
            {{user.name}}
          </li>
        </ul>
      </ShowPartialOrFullList>
    </div>
  </va-modal>
  <UpdateClusterModal v-if="isUpdatingCluster"
    :cluster="cluster"
    @clusterUpdated="onClusterUpdated"
    @cancel="onCloseUpdateModal"
  >
  </UpdateClusterModal>
</section>
</template>
<script>
import ShowPartialOrFullList from '@/components/common/ShowPartialOrFullList'
import UpdateClusterModal from './CreateUpdateClusterModal'
export default {
  props: {
    cluster: {
      type: Object,
      required: true
    }
  },
  components: {
    ShowPartialOrFullList,
    UpdateClusterModal
  },
  data: function () {
    return {
      isOpen: false,
      isUpdatingCluster: false
    }
  },
  mounted: function () {
    this.isOpen = true
  },
  computed: {
    clusterContainsUser: function () {
      return this.cluster.userIds.includes(this.$auth.user().id)
    },
  },
  methods: {
    closeModal: function () {
      setTimeout(() => this.$emit('cancel'), 500)
    },
    onClickUpdateCluster: function () {
      this.isOpen = false
      setTimeout(() => { this.isUpdatingCluster = true }, 500)
    },
    onCloseUpdateModal: function () {
      this.isUpdatingCluster = false
      this.isOpen = true
    },
    onClusterUpdated: function (payload) {
      this.$emit('clusterUpdated', payload)
    },
    formatEntity: function (entity) {
      let formattedString = entity.name
      if (entity.cities && entity.cities.length) {
        formattedString += '(' + entity.cities.join(', ') + ')'
      }
      return formattedString
    }
  }
}
</script>
